import { MAnalisisMethod } from "./analisis-method.model";
import { Cause, CauseByMethod, AnalisisMethod } from "../interfaces/treatment";
import { Evidence } from "../interfaces/Organization";
import { MCauseEvidence } from "./cause-evidence.model";

export class MCause {
  public id: number = null;
  public description: string = null;
  public method: MAnalisisMethod = null;
  public selected: boolean = false;
  public fatherId: number = null;
  public evidence: MCauseEvidence[] = [];
  public magnitude: number = 0;
  public diagramData: any = null;
  public definitiveId: number = null;
  public definitiveSelected: boolean = false;
  public descripcion: string = null;

  constructor(
    cause: {
      regular?: Cause;
      byMethod?: CauseByMethod;
    },
    method?: AnalisisMethod
  ) {
    if (cause.byMethod) {
      this.id = cause.byMethod.id ? cause.byMethod.id : null;
      this.description = cause.byMethod.texto;
      this.method = method ? new MAnalisisMethod(method) : null;
     // this.definitiveSelected = cause.byMethod.elegido
     //   ? cause.byMethod.elegido
     //   : true;
      this.selected = cause.byMethod.elegido || false;

      // this.magnitude = cause.byMethod.dato ? parseFloat(cause.byMethod.dato) : 0
      if (cause.byMethod.dato) {
        let data = JSON.parse(cause.byMethod.dato);
        this.magnitude = data.magnitude;
        this.diagramData = data.data;
      }
      this.fatherId = cause.byMethod.causa_metodo_nc_id
        ? parseInt(cause.byMethod.causa_metodo_nc_id)
        : null;
      this.evidence = cause.byMethod.evidencias
        ? cause.byMethod.evidencias.map((e) => new MCauseEvidence(e))
        : [];
    } else {
      this.id = cause.regular.id ? cause.regular.id : null;
      this.description = cause.regular.descripcion;
      this.method = cause.regular.metodo_analisis
        ? new MAnalisisMethod(cause.regular.metodo_analisis)
        : null;
      this.selected = cause.regular.seleccionado
        ? cause.regular.seleccionado
        : false;
      this.definitiveSelected = cause.regular.seleccionado
        ? cause.regular.seleccionado
        : false;

      this.magnitude = cause.regular.magnitud;
      // this.magnitude = cause.regular.magnitud ? cause.regular.magnitud : 0
    }
  }
}
